import { format } from 'date-fns';

function Professional({ id, name, photo, specialties, nextAvailableSlot, setFieldValue, booking }) {
    return (
        <div className="flex gap-6">
            <div
                className={`aspect-square w-28 flex-none overflow-hidden rounded shadow-md ${booking ? 'cursor-pointer' : ''}`}
                onClick={() => {
                    if (booking) {
                        setFieldValue('professional_id', id);
                        if (specialties.length == 1) {
                            setFieldValue('specialty_id', specialties[0].id);
                        } else {
                            setFieldValue('specialty_id', '');
                        }
                    }
                }}
            >
                {photo ? (
                    <img className="object-cover w-full h-full" src={photo} />
                ) : (
                    <div className="flex items-center justify-center h-full p-3 text-gray-300 bg-gray-100">
                        <svg className="h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 322.958 354.167">
                            <path
                                d="M161.438,354.167A207.989,207.989,0,0,1,0,277.292c5.4-12.25,16.313-20.73,38.9-25.959,46.75-10.791,92.9-20.437,70.687-61.354C43.854,68.729,90.854,0,161.438,0c69.208,0,117.374,66.188,51.854,189.979-21.563,40.667,22.916,50.334,70.687,61.354,22.542,5.209,33.542,13.646,38.979,25.854a207.955,207.955,0,0,1-161.52,76.98Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                )}
            </div>

            <div className="space-y-2">
                <div className="font-medium">
                    {booking ? (
                        <h3
                            className="cursor-pointer hover:underline"
                            onClick={() => {
                                setFieldValue('professional_id', id);
                                if (specialties.length == 1) {
                                    setFieldValue('specialty_id', specialties[0].id);
                                } else {
                                    setFieldValue('specialty_id', '');
                                }
                            }}
                        >
                            {name}
                        </h3>
                    ) : (
                        <h3>{name}</h3>
                    )}
                    <p className="text-xs text-blue-600">
                        {specialties.map(({ id: specialty_id, name }, index) => [
                            index > 0 && ', ',
                            booking ? (
                                <span
                                    className="cursor-pointer hover:underline"
                                    key={specialty_id}
                                    onClick={() => {
                                        setFieldValue('professional_id', id);
                                        setFieldValue('specialty_id', specialty_id);
                                    }}
                                >
                                    {name}
                                </span>
                            ) : (
                                <span key={specialty_id}>{name}</span>
                            ),
                        ])}
                    </p>
                </div>

                <div className="text-sm">
                    {nextAvailableSlot ? (
                        <div
                            className={`inline-block rounded border border-blue-200 bg-blue-100 px-2 py-1 capitalize text-blue-700 transition-colors ${booking ? 'cursor-pointer' : ''}`}
                            onClick={() => {
                                if (booking) {
                                    setFieldValue('professional_id', id);
                                    if (specialties.length == 1) {
                                        setFieldValue('specialty_id', specialties[0].id);
                                    } else {
                                        setFieldValue('specialty_id', '');
                                    }
                                    setFieldValue('date', format(new Date(nextAvailableSlot), 'yyyy-MM-dd'));
                                    setFieldValue('time', format(new Date(nextAvailableSlot), 'HH:mm'));
                                }
                            }}
                        >
                            {format(new Date(nextAvailableSlot), 'EEEE d MMMM, HH:mm', { locale: window.dateLocale })}
                        </div>
                    ) : (
                        <div className="inline-block px-2 py-1 text-gray-400 bg-gray-100 border border-gray-200 rounded">Sem horários disponíveis</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Professional;
